// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--3n2LW","form":"form--1Xyjo","card":"card--3uzeL","cardTitle":"cardTitle--1CC8p"};